// extracted by mini-css-extract-plugin
export default {"headerBar":"IJ-z","pointsSection":"JJ-z","goToDashboard":"KJ-z"};